import { createAction, props } from "@ngrx/store";
import {
  IThingSpaceGraph,
  ThingSpaceType,
  ISkillGroupPopularityModel,
} from "@skills-app/models/thingspaceGraph";
import { ICapability } from "@skills-app/models/capability";

const prefix = "[ThingSpace API]";

export const populateRevisions = createAction(
  `${prefix} Graph Loaded`,
  props<{ revisions: IThingSpaceGraph[] }>(),
);
export const revisionAdded = createAction(`${prefix} Revision Added`);
export const graphSkillAdded = createAction(`${prefix} Graph Skill Added`);
export const graphSkillDeleted = createAction(`${prefix} Graph Skill Deleted`);

export const populateDraft = createAction(
  `${prefix} Draft Loaded`,
  props<{ draft: IThingSpaceGraph }>(),
);

export const populateSkillPopularities = createAction(
  `${prefix} Skill Popularity Loaded`,
  props<{ SkillPopularities: ISkillGroupPopularityModel }>(),
);

// loading draft //
export const upsertedRevision = createAction(`${prefix} Revision Upserted`);
export const requestLoadDraft = createAction(
  `${prefix} Load Draft`,
  props<{ thingSpaceType: ThingSpaceType }>(),
);
export const requestSkillPopularities = createAction(
  `${prefix} Request Skill Popularities`,
);
export const loadedEditPage = createAction(`${prefix} Loaded Edit Page`);

export const requestCapability = createAction(
  `${prefix} Get Capability`,
  props<{ thingSpaceType: ThingSpaceType }>(),
);
export const populateCapability = createAction(
  `${prefix} Capability Loaded`,
  props<{ capability: ICapability }>(),
);
